import React, { useState, useEffect } from "react";
import styles from "./Schedule.module.css";
import BackGround from "../About Us/Background";
import Pune from "../../assets/pune.svg";
import Shilong from "../../assets/shilong.svg";
import Mumbai from "../../assets/mumbai.svg";
import Delhi from "../../assets/delhi.svg";

const cities = [
  {
    name: "DELHI",
    date: "NA",
    venue: "Online",
    img: Delhi,
  },
  {
    name: "BANGALORE - REGISTRATION CLOSED",
    date: "NA",
    venue: "Online",
    img: Shilong,
  },
  {
    name: "HYDERABAD",
    date: "NA",
    venue: "Online",
    img: Pune,
  },

  {
    name: "MUMBAI",
    date: "4/12/25",
    venue: "TBA",
    img: Mumbai,
  },
  {
    name: "SHILLONG",
    date: "NA",
    venue: "Online",
    img: Shilong,
  },
  {
    name: "PUNE - REGISTRATION CLOSED",
    date: "NA",
    venue: "ONLINE",
    img: Pune,
  },
  {
    name: "AHMEDABAD - REGISTRATION CLOSED",
    date: "NA",
    venue: "Online",
    img: Shilong,
  },
  {
    name: "KOLKATA",
    date: "NA",
    venue: "Online",
    img: Shilong,
  },
  {
    name: "GOA",
    date: "NA",
    venue: "ONLINE",
    img: Pune,
  },
  {
    name: "REST OF INDIA",
    date: "NA",
    venue: "Online",
    img: Shilong,
  },
];

const Schedule = () => {
  const [selectedCity, setSelectedCity] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setSelectedCity((prevCity) => (prevCity + 1) % cities.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isPaused]);

  const handleCityClick = (index) => {
    setIsPaused(true);
    setSelectedCity(index);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine styles based on window width
  const dynamicStyle =
    windowWidth > 770
      ? { top: `${selectedCity * 10}%`, left: "0", width: "3vh", height: "3vh" } // Move by top when width is greater than 770px
      : { left: `${selectedCity * 23}%`, top: "0" };

  return (
    <div className={styles.scheduleContainer}>
      <BackGround />
      <div className={styles.scheduleContainer_main}>
        <div className={styles.scheduleContainer_a}>
          <p className={styles.heading}>SCHEDULE</p>
          <div className={styles.scheduleBox}>
            <img
              src={cities[selectedCity].img}
              alt={selectedCity}
              className={styles.sched}
            />
            <p>Date - {cities[selectedCity].date}</p>
            <p>Venue - {cities[selectedCity].venue}</p>
          </div>
        </div>
        <div className={styles.cityList}>
          <div className={styles.cityListLine}></div>
          <div
            className={styles.circle}
            style={{
              ...dynamicStyle, // Apply the dynamic styles
            }}
          ></div>
          <div className={styles.name_city}>
            {cities.map((city, index) => (
              <p
                key={index}
                className={`${styles.cityItem} ${
                  index === selectedCity ? styles.selectedCity : ""
                }`}
                onClick={() => handleCityClick(index)}
              >
                {city.name}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
